/**
 * Replicated from: ooui\packages\wac-browsertelemetry\src\diagnostics\api\ULSTraceLevel.ts
 * that is auto generated from: https://dev.azure.com/Office/Office/_git/Office?path=/browsertelemetry/Diagnostics/API/Levels.cs
 *
 * We can't re-export the ULSTraceLevel enum from there since its not capitalized.
 *
 * Log/Trace level to be written
 *
 * @enum {number}
 */
export enum TraceLevel {
  /**
   * Error handling code paths, almost always unexpected, generally unrecoverable.
   * aka Unexpected
   */
  Error = 10,

  /**
   * Generally used for error-handling code paths that are occasionally expected
   * and/or usually handled appropriately.
   * aka Monitorable
   */
  Warning = 15,

  /**
   * Important events happening on the box that don't indicate an error or warning,
   * but are still be worth monitoring.
   * aka High
   */
  Important = 20,

  /**
   * Normal/expected code paths, used to indicate the "big" things that
   * are happening (e.g. activation, status updates).
   * aka Medium
   */
  Info = 50,

  /**
   * Intended only for developers/testers for the purposes of debugging issues.
   */
  Verbose = 100,

  /**
   * Generally not used, but expected to cause significant slow down (when on) and
   * significantly increase log size. Used only for debugging issues that are very
   * difficult to track down.
   * aka VerboseEx
   */
  Spam = 200,
}
